module.exports = __webpack_public_path__ + "img/cb2.93e0e7f1.jpg";